import React from 'react';
import { useLanguage } from 'apps/sigma2-ui/src/lib/hooks/useLanguage';
import { EditRubricComposableSection } from 'apps/sigma2-ui/src/components/rubrics/EditRubricComposableSection';
import { EditRubricRoleRulePreview } from 'apps/sigma2-ui/src/components/rubrics/EditRubricRoleRulePreview';
import { EditRubricSectionThread } from 'apps/sigma2-ui/src/components/rubrics/EditRubricSectionThread';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { EditRubricEditRoleRule } from 'apps/sigma2-ui/src/components/rubrics/EditRubricEditRoleRule';
import { EditableRubricRoleWithError } from 'libs/end-to-end/src/types/rubrics/rubric';
import { RubricRoleOperation } from 'libs/end-to-end/src/types/rubrics/rubric';
import cn from 'classnames';

const EditRubricJobOpeningSectionIcon: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="72"
      viewBox="0 0 72 72"
      fill="none"
    >
      <rect width="72" height="72" rx="20" fill="#080857" />
      <rect width="72" height="72" rx="20" fill="#080857" />
      <path
        d="M47.2402 38.1638C48.2271 38.1619 49.2049 38.3539 50.1172 38.7302C51.0296 39.1066 51.8591 39.6599 52.5576 40.3572C53.256 41.0543 53.8104 41.8822 54.1885 42.7937C54.5666 43.7053 54.7607 44.6827 54.7607 45.6697C54.7636 47.1578 54.3256 48.6136 53.501 49.8523C52.6764 51.0909 51.5028 52.0572 50.1289 52.6287C48.755 53.2001 47.242 53.3508 45.7822 53.0623C44.3225 52.7737 42.9809 52.0587 41.9277 51.0076C40.8745 49.9564 40.1566 48.6162 39.8652 47.157C39.5739 45.6977 39.7222 44.1844 40.291 42.8093C40.8598 41.4343 41.8235 40.2584 43.0605 39.4314C44.2976 38.6045 45.7523 38.1638 47.2402 38.1638ZM50.2822 41.8083C50.0401 41.6558 49.7469 41.6063 49.4678 41.6697C49.1887 41.733 48.9455 41.9041 48.793 42.1462L45.7588 47.0212L45.2129 46.4753C45.0107 46.2734 44.736 46.1599 44.4502 46.1599C44.1645 46.16 43.8906 46.2735 43.6885 46.4753C43.5868 46.5745 43.5054 46.6931 43.4502 46.824C43.3951 46.9547 43.3672 47.0952 43.3672 47.2371C43.3672 47.3791 43.395 47.5202 43.4502 47.6511C43.5054 47.782 43.5867 47.9006 43.6885 47.9998L45.127 49.4373C45.2414 49.5531 45.3807 49.6417 45.5342 49.696C45.6875 49.7503 45.851 49.7696 46.0127 49.7517C46.1746 49.7337 46.3309 49.6793 46.4688 49.5925C46.6064 49.5058 46.7224 49.3888 46.8086 49.2507L50.5625 43.24L50.6201 43.2966C50.7724 43.0546 50.8221 42.762 50.7588 42.4832C50.6954 42.2041 50.5243 41.9609 50.2822 41.8083ZM21.3145 41.906C21.4565 41.9041 21.5979 41.9307 21.7295 41.9841C21.8611 42.0376 21.9806 42.1171 22.0811 42.2175C22.1815 42.318 22.2609 42.4375 22.3145 42.5691C22.3679 42.7008 22.3945 42.842 22.3926 42.9841V46.5359H26.002C26.288 46.5359 26.5624 46.65 26.7646 46.8523C26.9669 47.0546 27.0811 47.329 27.0811 47.615C27.081 47.9009 26.9669 48.1755 26.7646 48.3777C26.5624 48.5798 26.2879 48.6931 26.002 48.6931H21.3281C21.0434 48.6893 20.7717 48.5742 20.5703 48.3728C20.369 48.1714 20.2538 47.8997 20.25 47.615V42.9841C20.25 42.7006 20.3614 42.4281 20.5605 42.2263C20.7597 42.0245 21.031 41.9098 21.3145 41.906ZM31.9248 36.8308C33.3954 36.4241 34.9464 36.4052 36.4268 36.7751C37.907 37.1451 39.2667 37.8914 40.373 38.9421C39.2408 40.067 38.4053 41.4557 37.9424 42.9832H25.7627C26.1719 41.5133 26.9544 40.1744 28.0342 39.0964C29.114 38.0184 30.4542 37.2376 31.9248 36.8308ZM34.3027 22.4187C35.9554 22.4225 37.5397 23.0818 38.707 24.2517C39.8743 25.4217 40.5292 27.0073 40.5293 28.6599C40.5293 29.8948 40.1629 31.102 39.4766 32.1287C38.7902 33.1553 37.815 33.9555 36.6738 34.4275C35.5326 34.8994 34.2765 35.022 33.0654 34.78C31.8546 34.538 30.7423 33.9423 29.8701 33.0681C28.998 32.1939 28.4052 31.0804 28.166 29.8689C27.9268 28.6573 28.0528 27.4016 28.5273 26.2615C29.0019 25.1215 29.804 24.1476 30.832 23.4636C31.8601 22.7798 33.068 22.4159 34.3027 22.4187ZM30.9668 26.3162C30.4774 26.9994 30.2155 27.8195 30.2188 28.6599C30.2188 29.7429 30.6493 30.7817 31.415 31.5476C32.1809 32.3134 33.2197 32.7438 34.3027 32.7439C35.2038 32.7416 36.0793 32.4418 36.792 31.8904C37.5046 31.339 38.0147 30.5667 38.2432 29.6951C36.8552 29.7093 35.4815 29.4135 34.2227 28.8289C32.9638 28.2442 31.8514 27.3858 30.9668 26.3162ZM26.002 18.7527C26.2778 18.7674 26.5376 18.8871 26.7275 19.0876C26.9175 19.2883 27.0238 19.5545 27.0234 19.8308C27.0274 20.1082 26.9222 20.3764 26.7314 20.5779C26.5407 20.7792 26.279 20.8987 26.002 20.9099H22.3926V24.4324C22.3945 24.5733 22.3681 24.7137 22.3154 24.8445C22.2628 24.9751 22.1848 25.0938 22.0859 25.1941C21.987 25.2944 21.8692 25.3741 21.7393 25.4285C21.6092 25.4828 21.4691 25.5115 21.3281 25.5115C21.0422 25.5114 20.7676 25.3972 20.5654 25.1951C20.3634 24.9928 20.25 24.7183 20.25 24.4324V19.8308C20.2537 19.5486 20.3664 19.2789 20.5645 19.0779C20.7628 18.8768 21.0321 18.7601 21.3145 18.7527H26.002ZM47.2422 18.7527C47.523 18.7602 47.7903 18.8767 47.9863 19.0779C48.1824 19.2793 48.292 19.5497 48.292 19.8308V24.4324C48.292 24.7183 48.1787 24.9928 47.9766 25.1951C47.7743 25.3973 47.4999 25.5115 47.2139 25.5115C46.9278 25.5115 46.6534 25.3973 46.4512 25.1951C46.249 24.9928 46.1357 24.7184 46.1357 24.4324V20.9099H42.6123C42.3263 20.9099 42.0519 20.7958 41.8496 20.5935C41.6473 20.3912 41.5332 20.1169 41.5332 19.8308C41.5332 19.5448 41.6474 19.2703 41.8496 19.0681C42.0519 18.866 42.3264 18.7527 42.6123 18.7527H47.2422Z"
        fill="url(#paint0_linear_564_17079)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_564_17079"
          x1="27.7553"
          y1="26.252"
          x2="53.8201"
          y2="52.8545"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.88" />
          <stop offset="1" stopColor="#3A3AE8" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const EditRubricJobOpeningSection: React.FC<{
  roles: EditableRubricRoleWithError[];
  onRoleNameChange: (index: number, name: string) => void;
  onRoleOperationChange: (
    index: number,
    operation: RubricRoleOperation,
  ) => void;
  onRoleSave: (index: number) => void;
  onRoleCancel: (index: number) => void;
  onRoleBeginEdit: (index: number) => void;
  onRoleRemove: (index: number) => void;
  onRoleCreate: () => void;
  onRoleSelect: () => void;
  isReadOnlyMode: boolean;
}> = ({
  roles,
  onRoleNameChange,
  onRoleOperationChange,
  onRoleCancel,
  onRoleSave,
  onRoleBeginEdit,
  onRoleRemove,
  onRoleCreate,
  onRoleSelect,
  isReadOnlyMode,
}) => {
  const language = useLanguage();

  return (
    <EditRubricComposableSection
      heading={language.editRubricJobOpeningSectionHeading()}
      subHeading={language.editRubricJobOpeningSectionSubHeading()}
      icon={<EditRubricJobOpeningSectionIcon />}
      onCreate={onRoleCreate}
      onSelect={onRoleSelect}
      isReadOnlyMode={isReadOnlyMode}
    >
      {roles.map((role, index) => (
        <EditRubricSectionThread key={index}>
          <Spacing
            direction="vertical"
            size="lg"
            className={cn('w-full', {
              'py-2': !role.draft,
              'py-4': role.draft,
            })}
          >
            {role.draft && (
              <EditRubricEditRoleRule
                onRoleNameChange={(name) => onRoleNameChange(index, name)}
                onRoleOperationChange={(op) => onRoleOperationChange(index, op)}
                onRoleSave={() => onRoleSave(index)}
                onRoleCancel={() => onRoleCancel(index)}
                roleName={role.draft.name}
                roleOperation={role.draft.roleOperation}
                requiredRoleError={role.requiredRoleError}
                duplicateRoleError={role.duplicateRoleError}
              />
            )}
            {!role.draft && role.record && (
              <EditRubricRoleRulePreview
                operation={role.record.roleOperation}
                name={role.record.name}
                onEdit={() => onRoleBeginEdit(index)}
                onRemove={() => onRoleRemove(index)}
                isReadOnlyMode={isReadOnlyMode}
              />
            )}
          </Spacing>
        </EditRubricSectionThread>
      ))}
    </EditRubricComposableSection>
  );
};
